import CtaSidebar from '@/components/_blog-updates/CtaSidebar';
import { CraftCtaSidebarProps } from './CraftCtaSidebar.types';
import { mapBlockToCtaSidebarProps } from './CraftCtaSidebar.utils';

const CraftCtaSidebar = ({ block }: CraftCtaSidebarProps) => {
  const props = mapBlockToCtaSidebarProps(block);

  return <CtaSidebar {...props} />;
};

export default CraftCtaSidebar;
